// src/components/Dealer/dealerStatus.ts

import type { DealerStatus } from '../../types/dealer';

/**
 * 딜러 상태 표시 (목록·상세 공통)
 *   active    활성
 *   pending   확인 중 — 종사원증 관리자 확인 대기. 앱·고객 화면은 그대로 이용
 *   suspended 이용정지 — 딜러 앱·고객 인증링크·프로필 모두 막힘
 *   inactive  탈퇴
 */
export const DEALER_STATUS: Record<DealerStatus, { label: string; className: string; description: string }> = {
  active: {
    label: '활성',
    className: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400',
    description: '딜러 앱과 고객 화면(인증링크·공개 프로필)을 정상적으로 이용하고 있습니다.',
  },
  pending: {
    label: '확인 중',
    className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/20 dark:text-amber-400',
    description:
      "종사원증 관리자 확인을 기다리는 중입니다. 딜러 앱과 고객 화면은 그대로 이용합니다. 위의 '확인됨으로 변경'으로 활성이 됩니다.",
  },
  suspended: {
    label: '이용정지',
    className: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-400',
    description:
      "딜러 앱과 고객 인증링크·공개 프로필이 막혀 있습니다. 딜러에게는 '고객센터로 문의해 주세요'만 보입니다.",
  },
  inactive: {
    label: '탈퇴',
    className: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    description: '탈퇴한 딜러입니다. 상태를 바꿀 수 없습니다.',
  },
};

/** 모르는 값(예전 rejected 등)은 원문 그대로 회색으로 */
export const dealerStatusOf = (status: string) =>
  DEALER_STATUS[status as DealerStatus] ?? {
    label: status,
    className: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
    description: '',
  };
